import { PAGE_STATUS_CHANGED, PAGE_ASSETS_LOADING } from '../actions/types';

const initialState = {
  status: 'initialized',
  loadingAssets: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case PAGE_STATUS_CHANGED:
      return {
        ...state,
        status: action.status,
      };
    case PAGE_ASSETS_LOADING:
      return {
        ...state,
        loadingAssets: action.loading,
      };
    default:
      return state;
  }
};
